import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const InputNumber = (props) => {
    let [value, setValue] = useState(props.value);
    useEffect(() => {
        numberCheck(value);
    }, value);
    const onChange = (e) => {
        numberCheck(e.target.value);
    };
    const numberCheck = (v) => {
        let num = v || 0;
        if (isFinite(num)) return;
        num = num.toString();

        if (num !== "0" && !num.includes(".")) {
            num = num.replace(/^0+/, "");
        }

        setValue(num);
    };

    return <input type="text" value={value} onChange={onChange}></input>;
};

const EditableDiv = (props) => {
    const { editable = true, change, data } = props;
    return (
        <div
            contentEditable={editable}
            suppressContentEditableWarning={true}
            onBlur={(e) => {
                if (e.target.innerHTML !== data.value) change(data, e.target.innerText);
            }}
            dangerouslySetInnerHTML={{ __html: data.value }}
        ></div>
    );
};

const EditableTd = (props) => {
    const { contentEditable = true, onBlur = () => {}, onInput = () => {}, style, className } = props;

    return (
        <td
            {...props.elements}
            style={{ ...style }}
            className={className}
            contentEditable={contentEditable}
            suppressContentEditableWarning={true}
            dangerouslySetInnerHTML={{ __html: props.children }}
            onBlur={onBlur}
            onInput={onInput}
        ></td>
    );
};

const EditableArea = (props) => {
    const { children, contentEditable } = props;
    const _props = { ...props };
    delete _props.children;
    return (
        <div
            suppressContentEditableWarning={true}
            dangerouslySetInnerHTML={{ __html: children }}
            contentEditable={contentEditable === undefined ? true : contentEditable}
            {..._props}
        ></div>
    );
};

const ClearableInput = (props) => {
    const { clear, ...others } = props;
    return (
        <div {...others}>
            <div className={"bpl-clearable-input"} style={{ position: "relative" }}>
                {props.children}
                <div className={"bpl-clearable-input-remove"}>
                    <div className={"bpl-clearable-input-remove-btn"} onClick={() => clear("")}>
                        <FontAwesomeIcon icon={faClose} />
                    </div>
                </div>
            </div>
        </div>
    );
};

const ContentEditableDiv = forwardRef((props, _ref) => {
    const inputRef = useRef(null);

    

    useImperativeHandle(_ref, () => ({
        innerHTML: (html) => {
            if(html) {
                inputRef.current.innerHTML = html;
                // SetA(html);
            } else {
                return inputRef.current.innerHTML
            }
        },
        innerText: (text) => {
            if(text) {
                inputRef.current.innerText = text;
            } else {
                return inputRef.current.innerText
            }
        },
        focus: () => {
            const selection = window.getSelection();
            const range = document.createRange();
            selection.removeAllRanges();
            range.selectNodeContents(inputRef.current);
            range.collapse(false);
            selection.addRange(range);
            inputRef.current?.focus();
        },
        blur: () => { 
            inputRef.current?.blur();
        }
    }));
    return (
        <div className={"bpl-content-editable-wrapper"}>
            <div
                className={"bpl-content-editable-dom nowrap"}
                suppressContentEditableWarning={true}
                contentEditable={true}
                ref={inputRef}
                dangerouslySetInnerHTML={{__html: props?.children}}
                {...props}
            />
        </div>
    );
});

const ContentEditableDivDesc = forwardRef((props, _ref) => {
    const inputRef = useRef(null);



    useImperativeHandle(_ref, () => ({
        innerHTML: (html) => {
            if(html) {
                inputRef.current.innerHTML = html;
                // SetA(html);
            } else {
                return inputRef.current.innerHTML
            }
        },
        innerText: (text) => {
            if(text) {
                inputRef.current.innerText = text;
            } else {
                return inputRef.current.innerText
            }
        },
        focus: () => {
            const selection = window.getSelection();
            const range = document.createRange();
            selection.removeAllRanges();
            range.selectNodeContents(inputRef.current);
            range.collapse(false);
            selection.addRange(range);
            inputRef.current?.focus();
        },
        blur: () => {
            inputRef.current?.blur();
        }
    }));
    return (
        <div className={"bpl-content-editable-wrapper-desc"}>
            <div
                className={"bpl-content-editable-dom nowrap"}
                suppressContentEditableWarning={true}
                contentEditable={true}
                ref={inputRef}
                dangerouslySetInnerHTML={{__html: props?.children}}
                {...props}
            />
        </div>
    );
});

export { InputNumber, EditableDiv, EditableTd, ClearableInput, EditableArea, ContentEditableDiv, ContentEditableDivDesc };
